import type { ReactElement } from 'react';
import type { IconBaseProps, IconType } from 'react-icons';

/** Compatible with @types/react 18.3+ (react-icons still types icons as ReactNode). */
export type SbrIconType = (props: IconBaseProps) => ReactElement;

type Props = {
  icon: IconType;
  size?: number;
  className?: string;
};

/** Renders an icon from `react-icons` with consistent sizing. */
export default function SbrIcon({ icon, size = 22, className }: Props) {
  const Icon = icon as SbrIconType;
  return <Icon size={size} aria-hidden className={className} />;
}
